// Mock data for blog posts - in production this would come from an API
const blogPosts = [
  {
    slug: 'how-to-analyze-financial-documents-with-ai',
    frontMatter: {
      title: "How to Analyze Financial Documents with AI",
      excerpt: "Learn how to leverage AI to extract insights from financial statements, reports, and spreadsheets automatically.",
      date: "2024-03-15",
      author: {
        name: "John Smith",
        avatar: "/avatars/john-smith.jpg",
        bio: "AI Research Lead at Predica.AI"
      },
      category: "Tutorials",
      tags: ["AI", "Finance", "Document Analysis", "Tutorial"],
      image: "/blog/images/financial-ai-header.jpg",
      readTime: "8 min read"
    }
  },
  // Add more blog posts here
];

export function getAllPostSlugs() {
  return blogPosts.map(post => ({
    params: {
      slug: post.slug
    }
  }));
}

export async function getPostBySlug(slug) {
  const post = blogPosts.find(post => post.slug === slug);
  if (!post) {
    throw new Error(`Post with slug "${slug}" not found`);
  }

  try {
    console.log('Fetching post content from:', `/blog/posts/${slug}.html`);
    const response = await fetch(`/blog/posts/${slug}.html`);
    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }
    const content = await response.text();
    console.log('Loaded content:', content);
    return {
      ...post,
      content
    };
  } catch (error) {
    console.error('Error loading blog post content:', error);
    throw error;
  }
}

export function getAllPosts() {
  // Sort posts by date
  return [...blogPosts].sort((a, b) => {
    return new Date(b.frontMatter.date) - new Date(a.frontMatter.date);
  });
} 